export default (end, start) => {
  const hourDiff = end.getTime() - start.getTime();
  const minDiff = hourDiff / 60 / 1000;
  const hDiff = hourDiff / 3600 / 1000;
  const hours = Math.floor(hDiff);
  const minutes = Math.ceil(minDiff - 60 * hours);
  const seconds = Math.ceil(hourDiff / 1000);

  const negativeCheck = value => value < 0 ? 0 : value;

  return {
    hours,
    minutes: negativeCheck(minutes),
    seconds: negativeCheck(seconds),
  };
}